$mol_locale_select $mol_select
	langs /string
		\en
